
export function renderNetraaLHReleaseNotes2 () {
    return (
  <div>
    <main className="transition-opacity duration-300">
      <div className="py-4">

        {/* Header */}
        <div id="details" className="mb-10 scroll-mt-24">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-wider text-orange-600 uppercase bg-orange-100 rounded-full dark:bg-orange-900/30 dark:text-orange-400">
            Release Notes
          </span>

          <h1 className="text-3xl lg:text-4xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
              Netraa LH Release Notes
            </span>
          </h1>

          <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
            Latest updates including feature enhancements, performance improvements, and bug fixes.
          </p>
        </div>

        {/* Confidentiality Statement */}
        {/* <section id="confidentiality" className="mb-12 scroll-mt-24">
          <div className="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 p-4 rounded-r-lg">
            <h4 className="text-sm font-bold text-red-800 dark:text-red-300 mb-2">
              Confidentiality Statement
            </h4>
            <p className="text-xs text-red-700 dark:text-red-400 leading-relaxed">
              The information contained in any Communication or Documentation distributed by ApMoSys...
            </p>
          </div>
        </section> */}

        {/* Release Details */}
        <section id="" className="mb-12 scroll-mt-24">
          <h2 className="text-xl font-bold text-text-main dark:text-white mb-4">
            Release Details
          </h2>

          <div className="overflow-x-auto border border-border-color dark:border-border-dark rounded-xl">
            <table className="w-auto text-left border-collapse text-sm">
              <thead>
                <tr>
                  <th className="px-4 py-3 font-bold text-text-muted">Release Date</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Release Type</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Author Name</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-3 font-medium text-primary">27th March 2026</td>
                  <td className="px-4 py-3">Enhancements & Fixes</td>
                  <td className="px-4 py-3">Navodya Tyagi</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Introduction */}
        <section id="introduction" className="mb-12 scroll-mt-24">
          <div className="p-6 rounded-2xl bg-gradient-to-r from-orange-50 to-transparent dark:from-orange-900/20 dark:to-transparent border border-border-color dark:border-border-dark">
            <h2 className="text-2xl font-bold text-text-main dark:text-white mb-3">
              Introduction
            </h2>
            <p className="text-sm text-text-muted dark:text-gray-400 leading-relaxed">
              Latest updates including feature enhancements, performance improvements, and bug fixes.
            </p>
          </div>
        </section>

        {/* Release Summary */}
        <section id="summary" className="mb-12 scroll-mt-24">
          <div className="p-6 rounded-2xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark">
            <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">
              Release Summary
            </h2>

            <p className="text-sm text-text-muted dark:text-gray-400 leading-relaxed">
              This release introduces key usability, functionality, and performance improvements...
            </p>
          </div>
        </section>

        {/* Features */}
        <section id="features" className="mb-16 scroll-mt-24">
          <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6">
            New Features & Enhancements
          </h2>

          <div className="space-y-6">
            {[
              {
                title: "Persistent Monitor Escalation",
                items: [
                  "Escalations remain active until manually resolved",
                  "Ensures critical issues stay visible"
                ]
              },
              {
                title: "Failed/Total Execution Metrics",
                items: [
                  "Displays failure ratio per monitor",
                  "Improves quick analysis"
                ]
              },
              {
                title: "Sorting by Last Run",
                items: [
                  "Sort monitors by last execution",
                  "Helps detect stale monitors"
                ]
              },
              {
                title: "Improved Global Client Filter",
                items: [
                  "Maintains page context when switching clients"
                ]
              },
              {
                title: "UI Enhancements for Filters",
                items: [
                  "Redesigned filters for better usability"
                ]
              }
            ].map((item, i) => (
              <div key={i} className="p-5 rounded-2xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark">
                <div className="flex gap-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-600 font-bold text-sm">
                    {i + 1}
                  </div>

                  <div>
                    <h4 className="font-semibold text-text-main dark:text-white mb-2">
                      {item.title}
                    </h4>

                    <ul className="list-disc pl-5 space-y-1 text-sm text-text-muted dark:text-gray-400">
                      {item.items.map((p, j) => (
                        <li key={j}>{p}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Performance */}
        <section id="performance" className="mb-10 scroll-mt-24">
          <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6">
            Performance Improvements
          </h2>

          <div className="space-y-6">
            {[
              {
                title: "Live Dashboard Optimization",
                items: [
                  "Faster data loading",
                  "Improved rendering performance"
                ]
              },
              {
                title: "KPI Dashboard Enhancements",
                items: [
                  "Faster queries for large time ranges"
                ]
              }
            ].map((item, i) => (
              <div key={i} className="p-5 rounded-2xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark">
                <div className="flex gap-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 font-bold text-sm">
                    {i + 1}
                  </div>

                  <div>
                    <h4 className="font-semibold text-text-main dark:text-white mb-2">
                      {item.title}
                    </h4>

                    <ul className="list-disc pl-5 space-y-1 text-sm text-text-muted dark:text-gray-400">
                      {item.items.map((p, j) => (
                        <li key={j}>{p}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Impact */}
        <section id="impact" className="mb-16 scroll-mt-24">
          <div className="p-8 bg-surface-light dark:bg-surface-dark">
            <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6">
              Impact Summary
            </h2>

            <div className="grid md:grid-cols-2 gap-4">
              <div className="p-5 rounded-2xl border border-blue-100 bg-blue-50/60">
                <h3 className="font-semibold mb-2">Operational Visibility</h3>
              </div>
              <div className="p-5 rounded-2xl border border-emerald-100 bg-emerald-50/60">
                <h3 className="font-semibold mb-2">Smoother Navigation</h3>
              </div>
              <div className="p-5 rounded-2xl border border-amber-100 bg-amber-50/60">
                <h3 className="font-semibold mb-2">Faster Data Access</h3>
              </div>
              <div className="p-5 rounded-2xl border border-rose-100 bg-rose-50/60">
                <h3 className="font-semibold mb-2">Better UX</h3>
              </div>
            </div>
          </div>
        </section>

      </div>
    </main>
  </div>
);
}